import Button from './Button';

// export types
export type { ButtonProps } from './Button';

// export components
export { Button };
export default Button;
